module.exports = __webpack_public_path__ + "img/strategy-chart.36462e06.svg";